webpackJsonp([7923024782231584000],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/photos-munich.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {
			"name": "munich",
			"photos": [
				"munich/DSC_0397.jpg",
				"munich/DSC_0399.jpg",
				"munich/DSC_0400.jpg",
				"munich/DSC_0403.jpg",
				"munich/DSC_0414.jpg",
				"munich/DSC_0415.jpg",
				"munich/DSC_0416.jpg",
				"munich/DSC_0419.jpg",
				"munich/DSC_0421.jpg",
				"munich/DSC_0423.jpg",
				"munich/DSC_0425.jpg",
				"munich/DSC_0427.jpg",
				"munich/DSC_0435.jpg",
				"munich/DSC_0443.jpg"
			],
			"next": {
				"name": "amsterdam"
			},
			"previous": {
				"name": "gothenburg"
			}
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---photos-munich-bc78870f8d0498ba093b.js